import React, { createContext, ReactNode, useContext, useState } from 'react';

interface SideMenuDrawerContextType {
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
  closeDrawer: () => void;
  openDrawer: () => void;
}

interface Props {
  children: ReactNode;
}

const SideMenuDrawerContext = createContext<SideMenuDrawerContextType>({
  isDrawerOpen: false,
  toggleDrawer: () => {},
  closeDrawer: () => {},
  openDrawer: () => {},
});

export const SideMenuDrawerProvider: React.FC<Props> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(prev => !prev);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  return (
    <SideMenuDrawerContext.Provider
      value={{
        isDrawerOpen,
        toggleDrawer,
        closeDrawer,
        openDrawer,
      }}
    >
      {children}
    </SideMenuDrawerContext.Provider>
  );
};

export const useSideMenuDrawer = (): SideMenuDrawerContextType =>
  useContext(SideMenuDrawerContext);
